import Vue from "vue";
import VueRouter from "vue-router";
import homePage from "@/pages/homePage/HomePage";
import listPage from "@/pages/applistPage/AppListPage"
import consoleLog from "@/utils/consoleLog";
import loginPage from "@/pages/loginPage/LoginPage";
import deviceListPage from "@/pages/deviceListPage/DeViceListPage";
import messageListPage from "@/pages/messageListPage/MessageListPage";
import localLogListPage from "@/pages/localLogListPage/LocalLogListPage";
import logDecryptPage from "@/pages/logDecryptPage/LogDecryptPage";
import onlineLogPage from "@/pages/onlineLogPage/OnlineLogPage";
import historyOnlineLogPage from "@/pages/historyOnlineLogPage/HistoryOnlineLogPage";
import userInfoPage from "@/pages/userInfoPage/UserInfoPage";
import deviceStatisticsPage from "@/pages/deviceStatisticsPage/DeviceStatisticsPage.vue";


Vue.use(VueRouter)
const routes = [
    {   /// childPage,childPage2,在homePage内执行跳转
        name: 'homePage', path: '/homePage', component: homePage,
        children: [
            {
                name: 'appListPage', path: '/appListPage', component: listPage,
                meta: {title: "应用列表"}
            },
            {
                name: 'deViceListPage', path: '/deViceListPage', component: deviceListPage,
                meta: {title: "设备列表"}
            },
            {
                name: 'deviceStatisticsPage', path: '/deviceStatisticsPage', component: deviceStatisticsPage,
                meta: {title: "设备统计"}
            },
            {
                name: 'messageListPage', path: '/messageListPage', component: messageListPage,
                meta: {title: "消息列表"}
            },
            {
                name: 'localLogListPage', path: '/localLogListPage', component: localLogListPage,
                meta: {title: "本地回捞日志"}
            },
            {
                name: 'logDecryptPage', path: '/logDecryptPage', component: logDecryptPage,
                meta: {title: "本地日志解密"}
            },
            {
                name: 'historyOnlineLogPage', path: '/historyOnlineLogPage', component: historyOnlineLogPage,
                meta: {title: "历史在线日志"}
            },
        ]
    },
    {
        name: 'loginPage', path: '/loginPage', component: loginPage,
        meta: {title: "登陆"}
    },
    {
        name: 'onlineLogPage', path: '/onlineLogPage', component: onlineLogPage,
        meta: {title: "在线日志"}
    },
    {
        name: 'userInfoPage', path: '/userInfoPage', component: userInfoPage,
        meta: {title: "用户信息"}
    },

]

const router = new VueRouter({routes})
// 获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
// 修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => {
        consoleLog.log("push err:" + err)
    })
}

///跳转前全局路由守卫/路由拦截器
router.beforeEach((to, from, next) => {
    consoleLog.log("beforeEach 全局路由守卫 to:" + to.name + ",from:" + from.name)
    if (!to.name) {
        next({
            //默认加载表单界面
            path: '/appListPage',
            query: {param1: 0}
        })
    } else {
        next()
    }
})


router.afterEach((to) => {
    if (to.meta.title) {
        document.title = to.meta.title
    } else {
        document.title = "InnerEyes"
    }
})


//当前窗口的跳转
window.doPush = function (context, path, query) {
    consoleLog.log("doPush path" + path + ",query ", query)

    ///路由跳转，和携带参数方法
    context.$router.push({
        path: path,
        query: query
    });
};

///全局Router跳转
window.globalDoPush = function (path, query) {
    consoleLog.log("globalDoPush path" + path + ",query ", query)
    ///路由跳转，和携带参数方法
    window.globalRouter.push({
        path: path,
        query: query
    });
};


//当前窗口的跳转,replace方法
window.replace = function (context, path, query) {
    consoleLog.log("replace name" + name + ",query ", query)

    //路由跳转，和携带参数方法 使用name跳转  name和path二选一
    // context.$router.replace({
    //     name: name,
    //     query: query
    // });
    context.$router.replace({
        path: path,
        query: query
    });
};

///打开新窗口跳转
window.doOpen = function (context, path, query) {
    consoleLog.log("doOpen path" + path + ",query ", query)
    let routeUrl = context.$router.resolve({
        path: path,
        query: query
    });
    window.open(routeUrl.href, '_blank')
};

export default router